import { render } from "./servers-sidebar.vue?vue&type=template&id=4f4c09e4"
import script from "./servers-sidebar.vue?vue&type=script&lang=js"
export * from "./servers-sidebar.vue?vue&type=script&lang=js"

import "./servers-sidebar.vue?vue&type=style&index=0&id=4f4c09e4&lang=css"
script.render = render

export default script